// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.statusIcon[data-v-a55b643e] {\r\n  font-size: 1.25em;\n}\r\n", ""]);
// Exports
module.exports = exports;
